<template>
  <div id="app">

    <div class="flex">
      <el-container>
        <el-aside>
          <el-header><img :src="Orlando" width="30px"></el-header>

          <el-menu :router="true" :collapse="true">
            <el-menu-item :route="{name:'home'}" index="1">
              <i class="fas fa-home"></i>
            </el-menu-item>
            <el-menu-item :route="{name:'colaboradores'}" index="2">
              <i class="fas fa-user"></i>
            </el-menu-item>
            <el-menu-item index="3" @click="sair">
              <i class="fas fa-sign-out-alt"></i>
              <span slot="title">Sair</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <el-main>
          <transition name="el-fade-in" mode="out-in" appear>
            <router-view />
          </transition>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import Orlando from './assets/orlando.png';

export default {
  data() {
    return {
      logado: false,
      isCollapse: true,
      Orlando
    };
  },
  methods: {
    setUser() {
      this.$store.dispatch('setUser');
    },
    sair() {
      this.$auth.signOut()
        .then(() => {
          this.$router.replace('login');
        });
    }
  },
  created() {
    // when the app is created run the set user method
    // this uses Vuex to check if a user is signed in
    // check out mutations in the store.js file
    this.setUser();
  }
};
</script>

<style lang="scss">
$roxo-claro: #7a7d92;
$roxo: #292c48;
$roxo-escuro: #1a1b29;
$verde: #43e695;
$verde-azul: #3bb2b8;
$vermelho: #f56c6c;
$branco: #fff;
$preto: #000;
$degrade-branco: linear-gradient(
  135deg,
  rgba($branco, 0) 0%,
  rgba($branco, 0.04) 100%
);
$degrade-branco-leve: linear-gradient(
  135deg,
  rgba(#ffffff, 0) 0%,
  rgba(#ffffff, 0.025) 100%
);
$degrade-verde: linear-gradient(135deg, $verde 0%, $verde-azul 100%);

*,
div {
  outline: none;
  box-sizing: border-box !important;
}

body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  background: $roxo;
}

h1 {
  margin: 0 0 10px;
}

.display-none {
  display: none;
}

.pointer {
  cursor: pointer;
}

::selection {
  color: $roxo-escuro;
  background: $verde;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

  .flex {
    display: flex;
    height: 100%;

    .el-header {
      height: auto !important;
      text-align: center;
      padding: 15px 0;
      background: rgba(0, 0, 0, 0.2);
    }

    .el-aside {
      background: $roxo-escuro;
      width: 64px !important;

      .el-menu {
        border: none;
        background-color: transparent;

        .el-menu-item {
          &:hover,
          &:focus {
            background: transparent;
          }

          &.is-active {
            color: $verde;
          }

          .fas {
            width: 24px;
            text-align: center;
            font-size: 18px;
            vertical-align: middle;
          }
        }
      }
    }

    .el-main {
      padding: 30px 50px;
      color: $branco;

      .header {
        margin: 0 0 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        .el-breadcrumb {
          .el-breadcrumb__inner {
            color: rgba($branco, 0.5);
          }
        }
      }
    }
  }
}

.blur {
  filter: blur(15px);
}

.espaco {
  flex: 1;
}

.el-row {
  &.flex {
    display: flex;
    flex-wrap: wrap;
  }
}

.el-switch {
  .el-switch__core {
    background: transparent;
    border-color: rgba($branco, 0.15);
  }

  &.is-checked {
    .el-switch__core {
      background: $verde;
      border-color: $verde;

      &:after {
        background-color: $roxo;
      }
    }
  }

  .el-switch__label {
    color: rgba($branco, 0.4);
  }
}

.el-form-item {
  &.is-error {
    input,
    textarea {
      border-color: $vermelho !important;
    }
  }

  &.is-success {
    input,
    textarea {
      border-color: $verde !important;
    }
  }

  .is-disabled {
    input,
    textarea {
      background-color: inherit !important;
      border-color: rgba($branco, 0.05) !important;
      color: rgba($branco, 0.4) !important;
    }
  }
}

.el-input-number__decrease,
.el-input-number__increase {
  background: $roxo-escuro;
  color: $branco;
  border-color: rgba($branco, 0.2);
}

.el-input__inner,
.el-textarea textarea {
  background: $degrade-branco;
  border: 1px solid rgba($branco, 0.15);
  color: $branco;

  &:focus {
    border: 1px solid rgba($verde, 1);
  }
}

.el-input-group__append,
.el-input-group__prepend {
  background-color: rgba($branco, 0.04);
  color: rgba($branco, 0.7);
  border: 1px solid rgba($branco, 0.15);
}
.el-input-group__append {
  border-left: none;
}
.el-input-group__prepend {
  border-right: none;
}

.el-picker-panel {
  .el-input__inner {
    color: #606266;
    border: 1px solid #dcdfe6;
  }
}

.el-dialog__wrapper {
  background: rgba($roxo, 0.6);
  padding: 0 20px;

  .el-dialog {
    border-radius: 5px;
    width: auto;
    max-width: 550px;
    border: 1px solid rgba($branco, 0.15);
    background: $degrade-branco;
    transition: all 0.3s;
    box-shadow: 0 40px 100px rgba($preto, 0.1);

    .el-dialog__title,
    .el-dialog__body,
    .el-form-item__label {
      color: $branco;
    }
  }
}

.el-message-box__wrapper {
  background: rgba($roxo, 0.6);
  padding: 0 20px;

  .el-message-box {
    border-radius: 5px;
    border: 1px solid rgba($branco, 0.15);
    background: $degrade-branco;
    transition: all 0.3s;
    box-shadow: 0 40px 100px rgba($preto, 0.1);

    &.el-message-box--center {
      .el-message-box__status {
        padding-right: 15px;
      }
    }

    .el-message-box__header,
    .el-message-box__content,
    .el-message-box__title {
      color: $branco;
    }
  }
}

.card {
  position: relative;
  border: 1px solid rgba($branco, 0.15);
  margin-bottom: 30px;
  border-radius: 5px;

  &:after {
    content: " ";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: $degrade-branco;
    z-index: 0;
    opacity: 0;
    transition: all 0.25s;
  }

  &:hover {
    box-shadow: 0 20px 80px rgba($preto, 0.15);

    &:after {
      opacity: 1;
    }
  }

  .card-content {
    position: relative;
    z-index: 1;
    background: transparent;
    padding: 15px;
    text-align: center;
    transition: all 0.25s;
    user-select: none;

    .avatar {
      margin: 0 auto;
    }

    .config {
      position: absolute;
      top: 15px;
      right: 15px;
      padding: 7px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $roxo;
      opacity: 0;
      transition: all 0.3s;
      background: $roxo-escuro;
      color: rgba($branco, 0.5);
      font-size: 12px;
      transform: translate(10px, -10px);

      &:hover {
        color: $verde;
      }
    }

    .desativar {
      position: absolute;
      top: 15px;
      right: 50px;
      padding: 7px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $roxo;
      opacity: 0;
      transition: all 0.3s;
      background: $roxo-escuro;
      color: rgba($branco, 0.5);
      font-size: 12px;
      transform: translate(10px, -10px);

      &:hover {
        color: $vermelho;
      }
    }

    .ativar {
      position: absolute;
      top: 15px;
      right: 50px;
      padding: 7px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $roxo;
      opacity: 0;
      transition: all 0.3s;
      background: $roxo-escuro;
      color: rgba($branco, 0.5);
      font-size: 12px;
      transform: translate(10px, -10px);

      &:hover {
        color: $verde;
      }
    }

    &:hover {
      .config {
        opacity: 1;
        transform: translate(0px, 0px);
      }

      .desativar {
        opacity: 1;
        transform: translate(0px, 0px);
      }

      .ativar {
        opacity: 1;
        transform: translate(0px, 0px);
      }
    }

    .info {
      .nome {
        font-weight: bold;
        margin: 15px 0 15px;
      }

      .horas {
        display: block;
        color: rgba($branco, 0.5);
        font-size: 12px;
        text-transform: uppercase;
        margin-bottom: 5px;
        letter-spacing: 1px;

        &:before {
          display: inline-block;
          content: " ";
          width: 10px;
          height: 10px;
          background: rgba($branco, 0.2);
          margin-right: 5px;
          border-radius: 50%;
          position: relative;
          top: 1px;
        }

        &.extra {
          &:before {
            background: $verde;
          }
        }

        &.falta {
          &:before {
            background: $vermelho;
          }
        }
      }

      .subtitulo {
        display: block;
        color: rgba($branco, 0.5);
        font-size: 12px;
        text-transform: uppercase;
        margin-bottom: 5px;
        letter-spacing: 1px;
      }
    }
  }

  .card-back {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;

    &.show {
      opacity: 1;
      z-index: 2 !important;
    }

    .fechar {
      position: absolute;
      top: 15px;
      right: 15px;
      background: $roxo-escuro;
      color: $branco;
      border: none;
    }
  }
}

.card-normal {
  position: relative;
  padding: 20px;
  height: 100%;
  border: 1px solid rgba($branco, 0.15);
  border-radius: 5px;
  transition: all 0.3s;
  background: $degrade-branco-leve;
  margin-bottom: 30px;

  h2 {
    font-size: 20px !important;
  }

  .avatar {
    margin: 0 auto;
  }

  .dia {
    padding: 20px 0 30px;
    margin: 0;
    position: relative;

    &.click {
      user-select: none;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid transparent;
      transition: all 0.3s;

      &:after {
        content: " ";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: $degrade-branco;
        z-index: 0;
        opacity: 0;
        transition: all 0.25s;
      }

      &:hover {
        box-shadow: 0 20px 80px rgba($preto, 0.15);
        border: 1px solid rgba($branco, 0.15);

        &:after {
          opacity: 1;
        }
      }
    }

    .data {
      color: $roxo-claro;
      text-transform: uppercase;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .hora {
      font-size: 24px;
      font-weight: 600;
      margin-right: 10px;
    }

    .justificativa {
      text-align: center;
      font-size: 14px;
      display: inline-block;
      color: rgba(255, 255, 255, 0.5);
      background: rgba(26, 27, 41, 0.3);
      padding: 8px 14px;
      border-radius: 50px;
      margin-top: 13px;
      margin-bottom: 0;
      user-select: none;
    }

    .fas {
      position: relative;
      top: -3px;
      margin-top: 10px;

      &.vermelho {
        color: #f56c6c;
      }

      &.verde {
        color: #43e695;
      }
    }
  }

  .horas {
    padding: 15px 0 25px;
    margin: 0;
    position: relative;

    &.click {
      user-select: none;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid transparent;
      transition: all 0.3s;

      &:after {
        content: " ";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: $degrade-branco;
        z-index: 0;
        opacity: 0;
        transition: all 0.25s;
      }

      &:hover {
        box-shadow: 0 20px 80px rgba($preto, 0.15);
        border: 1px solid rgba($branco, 0.15);

        &:after {
          opacity: 1;
        }
      }
    }

    .colaborador {
      color: $roxo-claro;
      text-transform: uppercase;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .horasColab {
      font-size: 24px;
      font-weight: 600;
      margin: 0;
    }
  }
}

.botao {
  position: relative;
  background: $verde !important;
  border: none;
  color: $roxo !important;
  transition: all 0.2s;

  &:before {
    content: " ";
    position: absolute;
    z-index: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: $degrade-verde;
    border-radius: 5px;
    transition: all 0.3s;
    opacity: 1;
  }

  &:hover {
    &:before {
      opacity: 0;
    }
  }

  &:active {
    background: $verde-azul !important;
  }

  span,
  i {
    position: relative;
    z-index: 1;
  }
}

.avatar {
  position: relative;
  width: 48px;
  height: 48px;
  background: $verde;
  background: $degrade-verde;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .avatar-ini {
    line-height: 48px;
    font-weight: bolder;
    color: $roxo;
    user-select: none;
    text-align: center;
    position: relative;
  }
}

.botao-cancelar {
  background: $roxo-escuro !important;
  color: $branco !important;
  border: none;
}

.carregando {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  text-align: center;

  i {
    margin: 0 auto;
    font-size: 30px;
  }
}

.horas-extras {
  text-align: center;
  font-size: 14px;
  display: inline-block;
  color: rgba(#fff, 0.5);
  background: rgba(#1a1b29, 0.3);
  padding: 8px 14px;
  border-radius: 50px;
  margin-top: 13px;
  margin-bottom: 0;

  &:before {
    display: inline-block;
    content: "";
    width: 10px;
    height: 10px;
    background: rgba(#ffffff, 0.2);
    margin-right: 5px;
    border-radius: 50%;
  }

  &.extra {
    &:before {
      background: #43e695;
    }
  }

  &.falta {
    &:before {
      background: #e83131;
    }
  }
}

@media (max-width: 481px) {
  .mobile-none {
    display: none;
  }

  #app {
    .flex {
      .el-aside {
        position: fixed;
        display: flex;
        bottom: 0;
        width: 100% !important;
        z-index: 1000;

        .el-header {
          display: none;
        }

        .el-menu {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }
      }

      .el-main {
        padding-bottom: 75px;

        .download-qrcode {
          display: none;
        }

        .header {
          .el-button + .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }
}
</style>
